export default __webpack_public_path__ + "static/media/biofit-builder-series-AJ.a4bc9bf5.png";